import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { check_in } from "../constants/choices";
import API_ROUTES from "../constants/apis";
import { isUserLoggedIn } from "../services/utils";

function BookingForm() {
  const [formData, setFormData] = useState({
    hostel: "",
    check_in_date: "",
  });

  const [residencies, setResidencies] = useState([]);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const loggedUser = isUserLoggedIn();

  useEffect(() => {
    const fetchResidencies = async () => {
      try {
        const response = await fetch(API_ROUTES.HOSTELS);
        const data = await response.json();
        setResidencies(data);
      } catch (error) {
        console.error("Error fetching residencies:", error);
      }
    };

    fetchResidencies();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const bookingData = {
      ...formData,
      user: loggedUser.user_id,
    };

    try {
      const response = await fetch(API_ROUTES.BOOKING, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bookingData),
      });

      if (response.ok) {
        setBookingSuccess(true);
      } else {
        console.error("Error submitting booking:", response.status);
      }
    } catch (error) {
      console.error("Error submitting booking:", error);
    }
  };
  return (
    <div className="bg-slate-300 flex flex-col justify-between h-screen">
      <Navbar />

      <div className="bg-slate-300 flex items-center justify-center px-5 pt-30 mt-40 mb-10">
        <form
          onSubmit={handleSubmit}
          className="max-w-sm mx-auto rounded-md text-blue-950"
        >
          <select
            name="hostel"
            value={formData.hostel || "defaultValue"}
            onChange={handleInputChange}
            className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none"
          >
            <option value="defaultValue" disabled>
              Select a Residence
            </option>
            {Array.isArray(residencies) &&
              residencies.map((residence) => (
                <option key={residence.id} value={residence.id}>
                  {residence.name}
                </option>
              ))}
          </select>

          <select
            name="check_in_date"
            value={formData.check_in_date || "defaultValue"}
            onChange={handleInputChange}
            className="w-full border-b border-blue-950 rounded-md py-2 px-4 focus:outline-none mt-2"
          >
            <option value="defaultValue" disabled>
              Select Check-In
            </option>
            {Object.entries(check_in).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>

          <button
            type="submit"
            className="w-full bg-red-600 hover:bg-red-700 text-white p-2 rounded-md mt-2"
          >
            Book Now
          </button>
        </form>
      </div>
      {bookingSuccess && (
        <p className="text-green-500 text-center text-4xl font-bold">
          Successfully Booked a Hostel.
        </p>
      )}
    </div>
  );
}

export default BookingForm;
